import React from 'react'

const colCase = [
  {
    question: '¿Durante qué periodo puedo participar?',
    answer: (
      <p>
        Puedes participar desde el 4 de marzo hasta el 31 de agosto de 2024.
        Puedes participar las veces que quieras.
      </p>
    ),
  },
  {
    question: '¿Puedo ganar varias veces durante la actividad? ',
    answer: <p>Puedes ganar solo 1 vez.</p>,
  },
  {
    question: '¿Cómo es la mecánica? ',
    answer: (
      <p>
        1. Ingresa la clave que aparece en tus empaques Nosotras®: obtén 3
        vidas con cada clave. 2. Si Nosotras® fue a tu colegio, revisa la
        revista que te entregaron porque allí encontrarás una clave especial que
        te dará 10 vidas. 3. Participa las veces que quieras en los 3 juegos
        disponibles en V School. Cada participación te acercará al top de
        jugadoras y todos los juegos te sumarán puntos.
      </p>
    ),
  },
  {
    question:
      '¿Cuántas veces puedo ingresar claves personales de empaques de Nosotras®? ',
    answer: (
      <p>
        Las veces que quieras. Recuerda que ganan las personas que más puntos
        acumulen.
      </p>
    ),
  },
  {
    question: '¿El premio se puede cambiar? ',
    answer: <p>No es canjeable, ni redimible en efectivo.</p>,
  },
  {
    question: '¿Qué pasa si no guardo los empaques?',
    answer: (
      <p>
        No podrás reclamar tu premio. Recuerda que para reclamar el premio
        deberás presentar TODOS los empaques de las claves que ingresaste al
        participar en la actividad, esto se deberá realizar cuando la marca te
        los solicite.
      </p>
    ),
  },
  {
    question: '¿Qué tipo de claves son válidas?',
    answer: (
      <p>
        Las claves que encuentras en tus empaques Nosotras® y la clave especial
        que encuentras en la revista que entregamos en tu colegio o que te llegó
        a tu correo. Esta clave especial solo podrás ingresarla 1 vez.
      </p>
    ),
  },
  {
    question: '¿Todas las claves me suman el mismo número de vidas?',
    answer: (
      <p>
        No, la primera clave especial te da 10 vidas, las demás ( de cualquier
        producto Nosotras®) te sumarán 3 vidas.
      </p>
    ),
  },
  {
    question: '¿Cuántas vidas suma la clave especial?',
    answer: <p>Te suma 10 vidas.</p>,
  },
  {
    question: '¿Dónde puedo adquirir las claves especial?',
    answer: (
      <p>
        En la revista que te entregan en la visita a tu colegio o mediante un
        mail que te llegará de Nosotras®.
      </p>
    ),
  },
  {
    question: '¿Puedo ingresar todas las claves de los productos?',
    answer: (
      <p>
        Sí, puedes ingresar todos los productos que tengan clave personal. Por
        ejemplo los de muestra gratis y de empaque individual no son válidos
        porque no tienen clave personal.
      </p>
    ),
  },
  {
    question: '¿Dónde está la clave personal de los empaques?',
    answer: (
      <p>
        Las claves las encuentras en el respaldo o en la parte lateral de los
        empaques. Es una combinación única de números y letras en mayúscula que
        tiene cada empaque.
      </p>
    ),
  },
  {
    question:
      'Si no gano ningún premio, ¿estos puntos me sirven para otra actividad?',
    answer: <p>No, estas claves ya no servirán para otras actividades.</p>,
  },
  {
    question: '¿Puedo jugar en muchos juegos al mismo tiempo?',
    answer: <p>Si, están habilitados al mismo tiempo.</p>,
  },
  {
    question: '¿Cuántas etapas serán?',
    answer: (
      <p>
        Es una sola etapa en la que puedes participar cuantas veces quieras.
        ¡Así que juega y sé súper constante para ganar!
      </p>
    ),
  },
  {
    question: '¿Cuántas ganadoras son?',
    answer: (
      <p>
        Del puesto 1 al 3, cada usuaria ganará 1 iPhone 14 de 128GB y una
        ancheta de productos Nosotras® que contiene: 1 Nosotras Panty
        Intimawear Flujo Regular, 1 Nosotras Pañitos Humedos Pro-Defense
        prebiotico x 16 NUEVA, 1 Nosotras Diarios Largos Con Alas Multiestilo x
        72 NUEVA, 1 Nosotras Jabon Intimo Agua de Rosas 200 ml NUEVA, 1 Nosotras
        Natural Buenas Noches x 10 Max Cur-V NUEVA, 1 Nosotras Diarios
        Multiestilo x 200 NUEVA y 1 Nosotras Tampon Aplicador Regular x 8 Nuevo.
        <br />
        Del puesto 4 al 10, cada usuaria ganará 1 Smart Watch y una ancheta de
        productos Nosotras® que contiene: 1 Nosotras Panty Intimawear Flujo
        Regular, 1 Nosotras Pañitos Humedos Pro-Defense prebiotico x 16 NUEVA, 1
        Nosotras Diarios Largos Con Alas Multiestilo x 72 NUEVA, 1 Nosotras
        Jabon Intimo Agua de Rosas 200 ml NUEVA, 1 Nosotras Natural Buenas
        Noches x 10 Max Cur-V NUEVA, 1 Nosotras Diarios Multiestilo x 200 NUEVA
        y 1 Nosotras Tampon Aplicador Regular x 8 Nuevo.
      </p>
    ),
  },
]

export const getQuestions = () => {
  switch (process.env.LOCALE) {
    case 'es-CO':
      return colCase
    case 'es-EC':
      return [
        {
          question: '¿Durante qué periodo puedo participar?',
          answer: (
            <p>
              Puedes participar desde el 1 de abril hasta el 30 de noviembre de
              2024. Puedes participar las veces que quieras.
            </p>
          ),
        },
        {
          question: '¿Puedo ganar varias veces durante la actividad? ',
          answer: <p>Puedes ganar solo 1 vez.</p>,
        },
        {
          question: '¿Cómo es la mecánica? ',
          answer: (
            <p>
              1. Ingresa la clave que aparece en tus empaques Nosotras®: obtén
              3 vidas con cada clave adicional. 2. Si Nosotras® fue a tu
              colegio, revisa la revista que te entregaron porque allí
              encontrarás una clave especial que te dará 5 vidas. 3. Participa
              las veces que quieras en los 3 juegos disponibles en V School.
              Cada participación te acercará al top de jugadoras y todos los
              juegos te sumarán puntos.
            </p>
          ),
        },
        {
          question:
            '¿Cuántas veces puedo ingresar claves personales de empaques de Nosotras®? ',
          answer: (
            <p>
              Las veces que quieras. Recuerda que ganan las personas que más
              puntos acumulen.
            </p>
          ),
        },
        {
          question: '¿El premio se puede cambiar? ',
          answer: <p>No es canjeable, ni redimible en efectivo.</p>,
        },
        {
          question: '¿Qué pasa si no guardo los empaques?',
          answer: (
            <p>
              No podrás reclamar tu premio. Recuerda que para reclamar el premio
              deberás presentar TODOS los empaques de las claves que ingresaste
              al participar en la actividad, esto se deberá realizar cuando la
              marca te los solicite.
            </p>
          ),
        },
        {
          question: '¿Qué tipo de claves son válidas?',
          answer: (
            <p>
              Las claves que encuentras en tus empaques Nosotras® y la clave
              especial que encuentras en la revista que entregamos en tu colegio
              o que te llegó a tu correo. Esta clave especial solo podrás
              ingresarla 1 vez.
            </p>
          ),
        },
        {
          question: '¿Todas las claves me suman el mismo número de vidas?',
          answer: (
            <p>
              No, la clave especial te da 5 vidas, las demás (de cualquier
              producto Nosotras) te sumarán 3 vidas.
            </p>
          ),
        },
        {
          question: '¿Cuántas vidas suma la clave especial?',
          answer: <p>Te suma 5 vidas.</p>,
        },
        {
          question: '¿Dónde puedo adquirir las claves especial?',
          answer: (
            <p>
              En la revista que te entregan en la visita a tu colegio o mediante
              un mail que te llegará de Nosotras®.
            </p>
          ),
        },
        {
          question: '¿Puedo ingresar todas las claves de los productos?',
          answer: (
            <p>
              Sí, puedes ingresar todos los productos que tengan clave personal.
              Por ejemplo los de muestra gratis y de empaque individual no son
              válidos porque no tienen clave personal.
            </p>
          ),
        },
        {
          question: '¿Dónde está la clave personal de los empaques?',
          answer: (
            <p>
              Las claves las encuentras en el respaldo o en la parte lateral de
              los empaques. Es una combinación única de números y letras en
              mayúscula que tiene cada empaque.
            </p>
          ),
        },
        {
          question:
            'Si no gano ningún premio, ¿estos puntos me sirven para otra actividad?',
          answer: (
            <p>No, estas claves ya no servirán para otras actividades.</p>
          ),
        },
        {
          question: '¿Puedo jugar en muchos juegos al mismo tiempo?',
          answer: <p>Si, están habilitados al mismo tiempo.</p>,
        },
        {
          question: '¿Cuántas etapas serán?',
          answer: (
            <p>
              Es una sola etapa en la que puedes participar cuantas veces
              quieras. ¡Así que juega y sé súper constante para ganar!
            </p>
          ),
        },
        {
          question: '¿Cuántas ganadoras son?',
          answer: (
            <p>
              Puesto 1: iPhone 14 de 128GB + Canasta de productos <br /> Puesto
              2: iPhone 14 de 128GB + Canasta de productos <br />
              Puesto 3: Auriculares Beats Solo3 Wireless + Canasta de productos
              <br />
              Puesto 4: Auriculares Beats Solo3 Wireless + Canasta de productos
              <br />
              Puesto 5: Reloj Smart Redmi watch lite 2 + Canasta de productos
              <br />
              Puesto 6: Reloj Smart Redmi watch lite 2 + Canasta de productos
              <br />
              Puesto 7: Reloj Smart Redmi watch lite 2 + Canasta de productos
              <br />
              Puesto 8: Reloj Smart Redmi watch lite 2 + Canasta de productos
              <br />
              Puesto 9: Reloj Smart Redmi watch lite 2 + Canasta de productos
              <br />
              Puesto 10: Reloj Smart Redmi watch lite 2 + Canasta de productos
              Canasta de productos: Prot. nosotras multiestilo x200 ,Tampón
              nosotras digital reg x10 ,Pañitos íntimos nosotras herbal x16,
              Jabón íntimo nosotras lavanda x200, Panty nosotras bikini , Toalla
              nosotras invisible rapigel x16 ,Toalla nosotras Básica Natural
              x10.4
            </p>
          ),
        },
      ]
    case 'es-PE':
      return [
        {
          question: '¿Durante qué periodo puedo participar?',
          answer: (
            <p>
              Puedes participar desde el 8 de abril hasta el 26 de noviembre de
              2024. Puedes participar las veces que quieras.
            </p>
          ),
        },
        {
          question: '¿Puedo ganar varias veces durante la actividad? ',
          answer: <p>Puedes ganar solo 1 vez.</p>,
        },
        {
          question: '¿Cómo es la mecánica? ',
          answer: (
            <p>
              1. Ingresa la clave que aparece en tus empaques Nosotras®: obtén
              3 vidas con cada clave adicional. 2. Si Nosotras® fue a tu
              colegio, revisa la revista que te entregaron porque allí
              encontrarás una clave especial que te dará 5 vidas. 3. Participa
              las veces que quieras en los 3 juegos disponibles en V School.
              Cada participación te acercará al top de jugadoras y todos los
              juegos te sumarán puntos.
            </p>
          ),
        },
        {
          question:
            '¿Cuántas veces puedo ingresar claves personales de empaques de Nosotras®? ',
          answer: (
            <p>
              Las veces que quieras. Recuerda que ganan las personas que más
              puntos acumulen.
            </p>
          ),
        },
        {
          question: '¿El premio se puede cambiar? ',
          answer: <p>No es canjeable, ni redimible en efectivo.</p>,
        },
        {
          question: '¿Qué pasa si no guardo los empaques?',
          answer: (
            <p>
              No podrás reclamar tu premio. Recuerda que para reclamar el premio
              deberás presentar TODOS los empaques de las claves que ingresaste
              al participar en la actividad, esto se deberá realizar cuando la
              marca te los solicite.
            </p>
          ),
        },
        {
          question: '¿Qué tipo de claves son válidas?',
          answer: (
            <p>
              Las claves que encuentras en tus empaques Nosotras® y la clave
              especial que encuentras en la revista que entregamos en tu colegio
              o que te llegó a tu correo. Esta clave especial solo podrás
              ingresarla 1 vez.
            </p>
          ),
        },
        {
          question: '¿Todas las claves me suman el mismo número de vidas?',
          answer: (
            <p>
              No, la clave especial te da 5 vidas, las demás (de cualquier
              producto Nosotras) te sumarán 3 vidas.
            </p>
          ),
        },
        {
          question: '¿Cuántas vidas suma la clave especial?',
          answer: <p>Te suma 5 vidas.</p>,
        },
        {
          question: '¿Dónde puedo adquirir las claves especial?',
          answer: (
            <p>
              En la revista que te entregan en la visita a tu colegio o mediante
              un mail que te llegará de Nosotras®.
            </p>
          ),
        },
        {
          question: '¿Puedo ingresar todas las claves de los productos?',
          answer: (
            <p>
              Sí, puedes ingresar todos los productos que tengan clave personal.
              Por ejemplo los de muestra gratis y de empaque individual no son
              válidos porque no tienen clave personal.
            </p>
          ),
        },
        {
          question: '¿Dónde está la clave personal de los empaques?',
          answer: (
            <p>
              Las claves las encuentras en el respaldo o en la parte lateral de
              los empaques. Es una combinación única de números y letras en
              mayúscula que tiene cada empaque.
            </p>
          ),
        },
        {
          question:
            'Si no gano ningún premio, ¿estos puntos me sirven para otra actividad?',
          answer: (
            <p>No, estas claves ya no servirán para otras actividades.</p>
          ),
        },
        {
          question: '¿Puedo jugar en muchos juegos al mismo tiempo?',
          answer: <p>Si, están habilitados al mismo tiempo.</p>,
        },
        {
          question: '¿Cuántas etapas serán?',
          answer: (
            <p>
              Es una sola etapa en la que puedes participar cuantas veces
              quieras. ¡Así que juega y sé súper constante para ganar!
            </p>
          ),
        },
        {
          question: '¿Cuántas ganadoras son?',
          answer: (
            <p>
              Puesto 1: Iphone 14 Rojo 128GB
              <br />
              Puesto 2: Tablet GALAXY A9
              <br />
              Puesto 3: Parlante JBL SPEAKER FLIP 6
              <br />
              Puesto del 4 al 10: SMARTWATCH 4 OBSIDIAN BLACK + kit de productos
              <br />
              -7 Nosotras invisible multiestilo x10
              <br />
              -7 Nosotras Pañitos Humedos Herbal x80
              <br />
              -7 Nosotras Buenas Noches
              <br />
              -7 Tampon Regular con aplicador x8
              <br />
              -7 Jabon Intimo Agua de Rosas x 200ml
              <br />
              -7 Nosotras Diarios con Alas x 72
            </p>
          ),
        },
      ]
    default:
      return colCase
  }
}
